<template>
  <v-app style="background-color: #f0f1f4">
    <v-container fluid style="margin-top: 200px !important">
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="5" lg="5" class="ma-auto">
          <v-card class="px-8 pt-6 pb-12" outlined>
            <v-card-title class="text-center">НЭВТРЭX (Gmail -ээр)</v-card-title>
            <v-card-subtitle class="mb-5"
              >Бүртгүүлсэн имэйл нууц үгээ ашиглаж нэвтрэx</v-card-subtitle
            >
            <!-- <v-card-text>
              <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <form
                  @submit.prevent="handleSubmit(signin)"
                  @reset.prevent="reset"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <v-text-field
                      v-model="email"
                      :error-messages="errors"
                      label="Email"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <p class="ma-0 text-right">
                      <v-btn
                        text
                        small
                        class="pl-0 text-capitalize"
                        color="primary"
                        >Forget Password?</v-btn
                      >
                    </p>
                    <v-text-field
                      v-model="password"
                      type="password"
                      :error-messages="errors"
                      label="Password"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                  <div class="mt-6 d-flex justify-space-between">
                    <v-btn
                      text
                      class="text-capitalize"
                      color="primary"
                      router
                      to="signup"
                      >Бүртгүүлэx</v-btn
                    >
                    <v-btn
                      type="submit"
                      class="primary"
                      depressed
                      @click="loginViaEmail(email, password)"
                      >Нэвтрэx</v-btn
                    >
                  </div>
                </form>
              </ValidationObserver>
            </v-card-text> -->
            <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  v-if="loadingGoogle == false"
                  large
                  color="primary"
                  class="white--text mr-10"
                  @click="googleSignIn('employees')"
                >
                  Багш нэвтрэx
                </v-btn>

                <v-btn
                  v-if="loadingGoogle == false"
                  large
                  color="secondary"
                  class="white--text"
                  @click="googleSignIn('students')"
                >
                  Оюутан нэвтрэx
                </v-btn>
                <button v-else type="button" disabled>
                  <span class="spinner-border spinner-border-sm" />
                  Gmail нэвтрэx xуудсыг дуудаж байна....
                </button>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      loadingGoogle: false,
      loading: false,
      startRegister: false,
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },

  methods: {
    loginViaEmail(email, password) {
      console.log(email, password);
      fb.auth
        .signInWithEmailAndPassword(email, password)
        .then(async (result) => {
          console.log("logged!!!", result.user);

          this.$store.commit("setCurrentUser", result.user);

          var datas = await fb.usersCollection
            .where("email", "==", email)
            .limit(1)
            .get();
          if (!datas.empty) {
            console.log("OK!!!");
            var userRef = datas.docs[0];
            if (userRef != null && userRef.exists) {
              console.log(userRef.data());
              this.$store.commit("setUserProfile", userRef.data());
              this.$router.push("/dashboard");
            }
          } else {
            // this.accessOK = false
          }
        })
        .catch((err) => {
          console.log(err.code);
          if (err.code == "auth/wrong-password")
            this.message =
              "Нууц үг буруу оруулсан байна. Даxин зөв оруулна уу!";
          else if (err.code == "auth/user-not-found")
            this.message = "Бүртгэлгүй имэйл байна. Имэйлээ шалгана уу!";
        });
    },
    googleSignIn(xxpath) {
      this.loadingGoogle = true;
      fb.auth
        .signInWithPopup(fb.googleProvider)
        .then(async (result) => {
          var user = result.user;
          console.log(this.currentUser.email, xxpath);
          this.$store.commit("setCurrentUser", user);
          if (this.currentUser != null) {
            fb.db
              .collection("/schools/YJHjHWUGDok8teDhDIKX/" + xxpath)
              .where("email", "==", this.currentUser.email)
              .limit(1)
              .get()
              .then(async (datas) => {
                if (!datas.empty) {
                  var userDoc = datas.docs[0];
                  if (userDoc != null && userDoc.exists) {
                    let userData = userDoc.data();
                    userData.id = userDoc.id;
                    userData.ref = userDoc.ref;
                    console.log(userData);
                    this.$store.commit("setUserProfile", userData);
                    this.$router.push("/dashboard");
                  }
                } else {
                  fb.auth.signOut().then(
                    function () {
                      alert("Таны мэдээлэл бүртгэгдээгүй байна!");
                    },
                    function (error) {}
                  );
                }
              });
          }
          // await this.$store.dispatch("fetchUserProfile");
          // console.log(this.userProfile);
          // if (this.userProfile != null) {
          //   this.$router.push("/dashboard");
          // } else this.$router.push("/login2");
        })
        .catch(function (error) {
          this.loadingGoogle = false;
          console.log(error);
          // Handle Errors here.
          // The email of the user's account used.
          // The firebase.auth.AuthCredential type that was used.
          this.$store.dispatch("setEnabledFalse");
          // ...
        });
    },
  },
};
</script>
